const Index = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/DemandMetrics')

export default [
  {
    path: 'demand-metrics',
    name: 'DemandMetrics',
    component: Index,
    meta: {
      title: 'Métricas de Demanda',
      ensureCanSeeFunctionalities: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/dashboard/demand-metrics.js